import React from "react";
import Plugins from "./plugins/index";
import WeaTextarea from "../wea-textarea";
import { convertSpecialChar, restoreSpeicalStr } from "./util";

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      random: `${new Date().getTime()}_${this.getHash()}`,
      that: this
    };
    if (!window.CK_REF) {
      window.CK_REF = {};
    }
  }
  componentDidMount() {
    const props = this.props;
    const { onStatusChange } = props;
    let newState = {};
    if ("value" in props) {
      newState = {
        ...newState,
        value: convertSpecialChar(props.value)
      };
    }
    this.setState(newState, () => {
      this.initEditor(props);
      typeof onStatusChange === "function" && onStatusChange("ready");
    });
  }
  componentWillReceiveProps(nextProps) {
    let newState = { random: `${new Date().getTime()}_${this.getHash()}` };
    if ("value" in nextProps) {
      newState = {
        ...newState,
        value: convertSpecialChar(nextProps.value)
      };
    }
    this.setState(newState, () => {
      this.initEditor(nextProps);
    });
  }
  initEditor = props => {
    const { id = "" } = props;
    const { random } = this.state;
    window.CK_REF[`wea_rich_text_wrap_${id}_${random}`] = this;
  };
  getHash = () =>
    Math.random()
      .toString(36)
      .substr(2, 6);
  // 获取底部工具栏
  getBootomBarItems() {
    const { bottomBarConfig = [] } = this.props;
    const items = [];
    const spanCom = (item, content) => (
      <span
        className={`wea-rich-text-toolbar-bottom-item ${
          item.disabled ? "wea-rich-text-toolbar-bottom-item-disabled" : ""
        }`}
        style={{ position: "relative", ...item.style }}
      >
        {content}
        {/* <span className="wea-rich-text-not-allowed" /> */}
      </span>
    );
    bottomBarConfig.forEach(item => {
      if (item.name === "Component") {
        items.push(spanCom(item, item.show));
      } else {
        const Tool = Plugins[item.name];
        items.push(
          spanCom(item, <Tool onToolsChange={this.onToolsChange} {...item} />)
        );
      }
    });
    return items;
  }

  onChange = value => {
    const { onChange } = this.props;
    value = convertSpecialChar(value);
    this.setState({ value });
    onChange && onChange(value);
  };

  onToolsChange = (type, ids, list, lev2Type) => {
    const { onToolsChange } = this.props;
    if (typeof onToolsChange === "function") {
      onToolsChange(type, ids, list, lev2Type);
    }
  };

  // 获取 editor
  getEditor = () => {
    return this.state.that;
  };

  // 获取数据
  getData = () => {
    return restoreSpeicalStr(this.state.value);
  };

  // 更新数据
  setData = (value, callback) => {
    this.setState(
      {
        value: convertSpecialChar(value)
      },
      callback
    );
  };

  focus = () => {
    const textarea = document.querySelector(".wea-rich-text textarea");
    if (textarea) {
      textarea.focus();
    }
  };

  onKeyDown = e => {
    const { onKeyDown } = this.props;
    onKeyDown && onKeyDown(e);
    e.stopPropagation();
  };

  render() {
    const props = this.props;
    const { value } = this.state;
    const { viewAttr, bottomBarConfig, bootomBarStyle } = props;
    return (
      <div className="wea-rich-text">
        <WeaTextarea
          minRows={10}
          maxRows={15}
          {...props}
          value={value}
          onKeyDown={this.onKeyDown}
          onChange={this.onChange}
        />
        {viewAttr != "1" && bottomBarConfig.length > 0 && (
          <div className="wea-rich-text-toolbar-bottom" style={bootomBarStyle}>
            {this.getBootomBarItems()}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/Textarea.js